import axios from "axios";

// Use the current page origin in the browser so the frontend works on
// any domain (preview URL, production *.emergent.host, or a custom
// domain like hrms.accountingfarm.com). Falls back to the env var for
// non-browser contexts (tests, SSR).
const isBrowser =
  typeof window !== "undefined" && window.location && window.location.origin;
const BACKEND_URL = isBrowser
  ? window.location.origin
  : process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && typeof window !== "undefined") {
      const path = window.location.pathname;
      if (!path.startsWith("/login") && !path.startsWith("/forgot")) {
        // do not auto-redirect to avoid loops; let pages handle
      }
    }
    return Promise.reject(e);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatINR(n) {
  if (n == null || isNaN(n)) return "—";
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(n);
}

export function monthName(m) {
  return new Date(2000, (m || 1) - 1, 1).toLocaleString("en-US", { month: "long" });
}

export const ROLE_LABEL = {
  super_admin: "Super Admin",
  hr_admin: "HR Admin",
  manager: "Manager",
  employee: "Employee",
};

export const STAGE_LABEL = {
  applied: "Applied",
  shortlisted: "Shortlisted",
  interview: "Interview",
  selected: "Selected",
  rejected: "Rejected",
  joined: "Joined",
};

export const STAGES = ["applied", "shortlisted", "interview", "selected", "rejected", "joined"];
